import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    width: 20,
    height: 20,
    zIndex: 20
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/File/EventButton/styles.js